import { request } from '@/utils/request';

const urls = {
  reimburseType: '/zlb/budget/dict/get-dict-by-type-code', // 报销类型
  economicSubject: '/zlb/budget/manage/getEconomicSubject', // 平台预算科目
  relationChange: '/zlb/budget/manage/budgetReimburseRelationChange', // 报销预算变更
  unlikeBudget: '/zlb/budget/manage/unlikeBudgetInfo', // 取消关联
  manageValidation: '/zlb/budget/manage/platformBudgetManageValidation', // 平台预算页面权限校验
};

export async function reqReimburseType(params) {
  return request(urls.reimburseType, { params });
}

export async function reqEconomicSubject(data) {
  return request(urls.economicSubject, { method: 'POST', data });
}

export async function reqRelationChange(data) {
  return request(urls.relationChange, { method: 'POST', data });
}

export async function reqUnlikeBudget(data) {
  return request(`${urls.unlikeBudget}/${data.relationId}`, { method: 'DELETE' });
}

export async function reqManageValidation() {
  return request(urls.manageValidation);
}
